import PropTypes from 'prop-types';

export default {
  availableQuantity: PropTypes.number,
  fastDelivery: PropTypes.bool,
  id: PropTypes.number,
  quantity: PropTypes.number,
  shippable: PropTypes.bool,
  title: PropTypes.string,
};
